import { createActionGroup, emptyProps, props } from '@ngrx/store'
import { FinancialYear, TaxSettings, TaxSlab } from './tax-settings.state'

export const taxSettingsActions = createActionGroup({
  source: 'Tax Settings',
  events: {
    'Load Financial Years': emptyProps(),
    'Load Financial Years Success': props<{ financialYears: FinancialYear[] }>(),
    'Load Financial Years Failure': props<{ error: string }>(),

    'Load Slabs And Rules': props<{ date: Date }>(),
    'Load Slabs And Rules Success': props<{ fyTaxSettings: TaxSettings }>(),
    'Load Slabs And Rules Failure': props<{ error: string }>(),

    'Add Slab': props<{ taxSlab: TaxSlab }>(),
    'Add Slab Success': props<{ taxSlab: TaxSlab }>(),
    'Add Slab Failure': props<{ error: string }>()
  }
})
